<template>
  <WebReport :url="url" :params="params" />
</template>

<script>
import { mapGetters } from 'vuex';
import WebReport from '@/components/web-report';
export default {
  components: {
    WebReport,
  },
  data() {
    return {
      url: '',
      params: {},
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'token']),
  },
  created() {
    console.log('this.userInfo:=>', this.userInfo);
    console.log('this.token:=>', this.token);
    this.params = {
      reportlet: 'pmsone_ycbs/pmsone_charger_coin_pay_log.cpt',
      account: this.userInfo.account,
      user: 1213,
    };
    this.url = 'http://rpt.pms1.cn/WebReport/ReportServer';
  },
};
</script>

<style></style>
